import React from "react";
import { FormGroup, Label, Input, Spinner, Badge, CustomInput } from "reactstrap";
import { NumberFormatInput } from "../NumberFormatInput/NumberFormatInput";
import classnames from "classnames";
import { Autosuggest, CircularProgress } from "..";
import style from "./styles.module.scss";

export const FormNumber = ({
  name,
  label,
  changedColor = false,
  value,
  onChange,
  error,
  disabled,
  decimalScale,
  dataTypeDecimalName,
  ...rest
}) => {
  return (
    <FormGroup>
      <Label
        style={{
          fontWeight: 500,
          fontSize: "15px",
          display: "block",
          color: changedColor ? "#36a9e1" : "black",
        }}
      >
        {label}
      </Label>
      <NumberFormatInput
        type="text"
        placeholder={label}
        customInput={Input}
        value={value}
        invalid={!!error}
        disabled={disabled}
        onValueChange={(e) => onChange(name, e.value)}
        decimalScale={decimalScale}
        dataTypeDecimalName={dataTypeDecimalName}
        {...rest}
      />
      <div className="invalid-feedback" style={{ display: error ? "block" : "none" }}>
        {error}
      </div>
    </FormGroup>
  );
};

export const FormCheck = ({
  name,
  label,
  changedColor = false,
  className = "",
  value,
  onChange,
  disabled,
}) => (
  <CustomInput
    type="checkbox"
    label={label}
    id={name}
    checked={value}
    disabled={disabled}
    onChange={onChange}
    className={classnames(className, {
      [style.customCheckChanged]: changedColor,
    })}
  />
);

export const Suggest = ({
  name,
  label,
  changedColor = false,
  valueId,
  valueName,
  fieldId,
  fieldName,
  fieldExtension,
  getSelectItemId,
  getSelectItemName,
  getSelectItemExtension,
  service,
  onChange,
  error,
  disabled,
}) => {
  const fetchSearch = ({ value }) => {
    return service({
      text: value,
      length: 10,
      type: "",
    })
      .then((res) => res.response || res)
      .then((res) => res[Object.keys(res)[0]])
      .then((values) => values);
  };

  const internalOnChange = (method, nextValue) => {
    const value = {
      [fieldId]: null,
      [fieldName]: "",
    };
    if (fieldExtension) {
      value[fieldExtension] = "";
    }
    if (method != "type" && getSelectItemId(nextValue)) {
      value[fieldId] = getSelectItemId(nextValue);
      value[fieldName] = getSelectItemName(nextValue);
      if (fieldExtension) {
        value[fieldExtension] = getSelectItemExtension(nextValue);
      }
    }
    onChange(name, value);
  };

  return (
    <FormGroup>
      {label && (
        <Label
          style={{
            fontWeight: 500,
            fontSize: "15px",
            display: "block",
            color: changedColor ? "#36a9e1" : "black",
          }}
        >
          {label}
        </Label>
      )}
      <Autosuggest
        renderSuggestion={(suggestion) => (
          <div className={style.suggestionItem}>
            <span>{getSelectItemName(suggestion)}</span>
          </div>
        )}
        getSuggestionValue={getSelectItemName}
        onSuggestionsFetchRequested={fetchSearch}
        value={valueName || ""}
        inputProps={{
          placeholder: label,
          invalid: !!error,
          disabled,
        }}
        onChange={(m, v) => internalOnChange(m, v)}
      />
      <div className="invalid-feedback" style={{ display: error ? "block" : "none" }}>
        {error}
      </div>
    </FormGroup>
  );
};

export function FormSelect({
  label,
  changedColor = false,
  value,
  name,
  disabled = false,
  onChange = () => {},
  selectItems,
  getSelectItemId,
  getSelectItemName,
  error,
  description,
}) {
  const getValueFromId = (id) => {
    for (let i = 0; i < selectItems.length; i += 1) {
      if (String(getSelectItemId(selectItems[i])) === String(id)) {
        return getSelectItemName(selectItems[i]);
      }
    }
    return "";
  };

  const isEmpty = (value) => value === undefined || value === "";

  return (
    <FormGroup>
      <Label
        style={{
          fontWeight: 500,
          fontSize: "15px",
          display: "block",
          color: changedColor ? "#36a9e1" : "black",
        }}
      >
        {label}
      </Label>
      <Input
        type="select"
        disabled={disabled}
        value={isEmpty(value) ? -1 : value}
        onChange={(e) => onChange(name, e.target.value, getValueFromId(e.target.value))}
      >
        {(value === undefined || value === "" || value === -1) && (
          <option value={-1} disabled>
            No item selected
          </option>
        )}
        {selectItems.map((s) => (
          <option key={getSelectItemId(s)} value={getSelectItemId(s)}>
            {getSelectItemName(s)}
          </option>
        ))}
      </Input>
      <div className="invalid-feedback" style={{ display: error ? "block" : "none" }}>
        {error}
      </div>
      {!error && description && (
        <div className="valid-feedback" style={{ display: "block", color: "gray" }}>
          {description}
        </div>
      )}
    </FormGroup>
  );
}
export const LoadingField = ({ label }) => (
  <FormGroup>
    <Label>{label}</Label>
    <div className="d-flex mt-2 mb-3">
      <Spinner size="sm" color="primary" />
      <span className="ml-2">Loading values</span>
    </div>
  </FormGroup>
);

export const LoadingMessage = ({ text }) => (
  <div className={style.loadingMessage}>
    <CircularProgress sm style={{ margin: "0px" }} />
    <span>{text}</span>
  </div>
);

export const Status = ({ status }) => {
  return (
    <Badge className={classnames({ [style.status]: true }, { [style[status.toLowerCase()]]: true })}>
      {status.toUpperCase()}
    </Badge>
  );
};
